import React from 'react';
import Popup from '../../Popup';

import styles from './confirmActionPopup.scss';

const ConfirmActionPopup1Btn = props => {
    const {
        onCloseClick,
        onCtaClick,
        confirmationTitle,
        confirmationMessage,
        confirmationDataValue,
        confirmButtonLabel = 'Confirm',
    } = props;
    return (
        <Popup
            className={`popup-sm`}
            popUpClassName={`${styles.confirmActionPopup}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
            }}
        >
            <div className={`${styles.section} pt0`}>
                <h5>{confirmationTitle}</h5>
            </div>
            <div className={`${styles.section} pt0`}>
                <div className="row">
                    <div className="col-12">
                        <p>{confirmationMessage}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 mb8">
                        <button
                            onClick={(ev) => {
                                onCtaClick(ev, confirmationDataValue);
                            }}
                            type="button"
                            className="btn btn-primary text-uppercase btn-block"
                        >
                            {confirmButtonLabel}
                        </button>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default ConfirmActionPopup1Btn;
